<section class="flex max-h-[90dvh] w-full flex-col overflow-hidden bg-white text-gray-900" role="alertdialog">
  <div class="crm-scroll flex min-h-0 flex-1 items-start gap-4 overflow-auto px-6 pb-5 pt-6">
    <div class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-amber-50 text-amber-500">
      <app-icon>warning</app-icon>
    </div>

    <div class="flex min-w-0 flex-1 flex-col gap-3">
      <h2 class="m-0 whitespace-pre-wrap break-words text-base font-semibold leading-6 text-gray-900">
        {{ (data.title | translate) || ('warning' | translate) }}
      </h2>

      <p class="m-0 whitespace-pre-wrap break-words text-sm leading-5 text-gray-600 {{ data.customClass }}">
        {{ !data?.isTranslate ? (data.text | translate) || ('warning' | translate) + '!' : data.text }}
      </p>

      @if (data.price) {
        <div class="flex items-center justify-between gap-3 rounded-xl bg-gray-50 px-4 py-3 text-sm">
          <span class="text-gray-600">{{ 'to_be_paid' | translate }}</span>
          <span class="font-semibold text-gray-900">{{ data.price }} {{ 'UAH' | translate }}</span>
        </div>
      }

      @if (data?.template) {
        <ng-container [ngTemplateOutlet]="data.template"></ng-container>
      }

      @if (data.checkbox) {
        <app-checkbox [(ngModel)]="data.checkbox.value">
          {{ data.checkbox.label | translate }}
        </app-checkbox>
      }
    </div>

    <button
      type="button"
      class="-mr-2 -mt-2 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-gray-400 hover:bg-gray-100 hover:text-gray-600"
      [attr.aria-label]="'close' | translate"
      [mat-dialog-close]="false"
    >
      <app-icon>close</app-icon>
    </button>
  </div>

  <footer class="flex shrink-0 flex-wrap items-center justify-end gap-2 border-t border-gray-100 bg-gray-50 px-6 py-3">
    <app-button [btnType]="'cancel'" [mat-dialog-close]="false">
      {{ data.cancelText | translate }}
    </app-button>
    <app-button (onChangeClick)="onConfirm()">
      {{ data.confirmText | translate }}
    </app-button>
  </footer>
</section>
